import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Lightbox from 'react-images'

export default class Gallery extends Component {
  state = {
    open: false,
    current: 0
  }

  close = () => this.setState({ open: false })

  open = (idx) => this.setState({
    open: true,
    current: idx
  })

  getNextIndex = () => {
    const { current } = this.state
    const totalImages = this.props.images.length
    if ((current + 1) >= totalImages) {
      return 0
    }
    return current + 1
  }

  getPrevIndex = () => {
    const { current } = this.state
    if ((current - 1) < 0) {
      return 0
    }
    return current - 1
  }

  next = () => this.setState({
    current: this.getNextIndex()
  })

  prev = () => this.setState({
    current: this.getPrevIndex()
  })

  render() {
    const { open, current } = this.state
    const { images } = this.props

    return (
      <Fragment>
        <Container>
          {images.map((image, idx) => (
            <Image
              key={idx}
              src={image}
              onClick={() => this.open(idx)}
            />
          ))}
        </Container>
        <Lightbox
          currentImage={current}
          images={images.map(img => ({ src: img }))}
          isOpen={open}
          onClickPrev={this.prev}
          onClickNext={this.next}
          onClose={this.close}
        />
      </Fragment>
    )
  }
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: wrap;
`

const Image = styled.img`
  max-width: 120px;
  margin: 1rem;
  cursor: pointer;
  transition: all .2s linear;
  
  &:hover {
    transform: scale(1.05)
  }
`
